import React from 'react'
import { useApolloClient } from '@apollo/client/react'
import AsyncCreatableSelect from 'react-select/async-creatable'
import type { SelectAsyncCreatableProps } from './index'
import { setupLoadOptions, setupOptionLabel } from './index'
import { useReactSelect } from './useReactSelect'
import { useDebouncedLoadOptions } from './useDebouncedLoadOptions'
import { useLoadOptionsFailure } from './useLoadOptionsFailure'
import { asyncLoadingMessage } from './AsyncLoadingMessage'

export const SelectAsyncCreatable = ({
  loadOptions,
  dataLoadOptions,
  defaultOptions = true,
  getOptionLabel,
  labelKey = 'label',
  onChange,
  onInputChange,
  loadingMessage,
  ...props
}: SelectAsyncCreatableProps) => {
  const client = useApolloClient()
  const loadFailure = useLoadOptionsFailure(props.components)

  if (!getOptionLabel) {
    getOptionLabel = setupOptionLabel(labelKey)
  }

  if (!loadOptions) {
    loadOptions = setupLoadOptions({
      client,
      dataLoadOptions,
      getOptionLabel,
      onLoadSettled: loadFailure.onLoadSettled,
      latestRequest: loadFailure.latestRequest,
    })
  }

  const debouncedLoadOptions = useDebouncedLoadOptions(loadOptions)

  const handleOnChange = (newValue, actionMeta) => {
    onChange?.(newValue, actionMeta)
  }
  const handleOnInputChange = (inputValue, actionMeta) => {
    onInputChange?.(inputValue, actionMeta)
  }

  const properties = useReactSelect(props)

  return (
    <AsyncCreatableSelect
      {...properties}
      onChange={handleOnChange}
      onInputChange={handleOnInputChange}
      loadOptions={debouncedLoadOptions}
      getOptionLabel={getOptionLabel}
      defaultOptions={defaultOptions}
      components={loadFailure.components}
      loadingMessage={loadingMessage ?? asyncLoadingMessage}
    />
  )
}
